import { type FC } from 'react';

export const Component: FC = () => {
  return <div>Component Detail</div>;
};
